// -----------------------------------------------------------------------------------------------------------------
//------------------------------------------------- For Discover Page------------------------------------------------
// -----------------------------------------------------------------------------------------------------------------
import art from "../assets/images/Discover/art.png";
import VirtualWorlds from "../assets/images/Discover/augmented.png";
import Photography from "../assets/images/Discover/camera (1).png";
import DomainNames from "../assets/images/Discover/cryptocurrency.png";
import Collectibles from "../assets/images/Discover/hand-gesture.png";
import Music from "../assets/images/Discover/musical-note.png";
import Sports from "../assets/images/Discover/sport.png";



import creativeCollProfile from '../assets/images/Discover/creativeCollProfile.png';

import postImage02 from '../assets/images/HomePage/postImage02.png';
import postImage03 from '../assets/images/HomePage/postImage03.png';
import postImage04 from '../assets/images/HomePage/postImage04.png';
import postImage05 from '../assets/images/HomePage/postImage05.png';
import postImage06 from '../assets/images/HomePage/postImage06.png';

import p1 from '../assets/images/HomePage/p 01.png';
import p5 from '../assets/images/HomePage/p 05.png';


import lowKey from '../assets/images/HomePage/low key.png';





export interface disoverCatagoriesDataType {
    id: number,
    name: string,
    photo: string,
    color: string,
}

export const disoverCatagoriesData: disoverCatagoriesDataType[] = [
    {
        id: 1,
        name: 'Art',
        photo: art,
        color: 'linear-gradient(180deg, #5D32E9 0%, #2B06A4 100%)',
    },
    {
        id: 2,
        name: 'Collectibles',
        photo: Collectibles,
        color: 'linear-gradient(180deg, #2BCDE4 0%, #127FDF 100%)',
    },
    {
        id: 3,
        name: 'Domain Names',
        photo: DomainNames,
        color: 'linear-gradient(180deg, #34C77B 0%, #009160 100%)',
    },
    {
        id: 4,
        name: 'Virtual Worlds',
        photo: VirtualWorlds,
        color: 'linear-gradient(180deg, #F6C000 0%, #C88500 100%)',
    },
    {
        id: 5,
        name: 'Photography',
        photo: Photography,
        color: 'linear-gradient(180deg, #2081E2 0%, #0053A5 100%)',
    },
    {
        id: 6,
        name: 'Music',
        photo: Music,
        color: 'linear-gradient(180deg, #EB5757 0%, #AB0000 100%)',
    },
    {
        id: 7,
        name: 'Sports',
        photo: Sports,
        color: 'linear-gradient(180deg, #2081E2 0%, #0052A2 100%)',
    },
    {
        id: 8,
        name: 'Trading Cards',
        photo: VirtualWorlds,
        color: 'linear-gradient(180deg, #E932BE 0%, #C40095 100%)',
    },
    {
        id: 9,
        name: 'Utility',
        photo: Photography,
        color: 'linear-gradient(180deg, #F2994A 0%, #E46B00 100%)',
    },
]







export interface discoverFeaturedCollectionsType {
    id: number,
    thumbs: {
        id: number,
        source: string,
        isVideo?: boolean,
        videoSrc?: string,
    }[],
    profilePhoto: string,
    profileName: string,
    isVerified: boolean,
    isMyLoved?: boolean,
    owner: string,
    loves: number,
}

export const discoverFeaturedCollections: discoverFeaturedCollectionsType[] = [
    {
        id: 1,
        thumbs: [
            { id: 1, source: postImage03 },
            { id: 2, source: postImage05 },
            { id: 3, source: postImage02 },
            { id: 4, source: postImage04 },
            { id: 5, source: postImage06 },
            { id: 6, source: postImage03 },
            { id: 7, source: 'https://cdn.pixabay.com/photo/2022/05/21/16/00/butterfly-7211806_960_720.jpg' },
            { id: 8, source: 'https://cdn.pixabay.com/photo/2022/05/16/19/14/road-7201023_960_720.jpg' },
        ],
        profilePhoto: creativeCollProfile,
        profileName: "Creative Art Collection",
        isVerified: true,
        isMyLoved: true,
        owner: "Ralph Garraway",
        loves: 1234,
    },
    {
        id: 2,
        thumbs: [
            { id: 1, source: postImage03 },
            { id: 2, source: postImage05 },
            { id: 3, source: 'https://cdn.pixabay.com/photo/2016/10/25/12/28/iceland-1768744_960_720.jpg' },
            { id: 4, source: postImage04 },
            { id: 5, source: postImage06 },
            { id: 6, source: postImage03 },
            { id: 7, source: postImage05 },
            { id: 8, source: postImage02 },
            { id: 9, source: postImage04 },
            { id: 10, source: "https://cdn.pixabay.com/photo/2018/07/10/10/29/girl-3528292_960_720.jpg" },
        ],
        profilePhoto: creativeCollProfile,
        profileName: "Creative Art Collection",
        isVerified: true,
        owner: "Ralph Garraway",
        loves: 1234,
    },
    {
        id: 3,
        thumbs: [
            { id: 1, source: postImage03 },
            { id: 2, source: postImage05 },
            { id: 3, source: postImage02 },
            { id: 4, source: postImage04 },
            { id: 5, source: postImage06 },
            { id: 6, source: postImage06 },
        ],
        profilePhoto: creativeCollProfile,
        profileName: "Creative Art Collection",
        isVerified: true,
        owner: "Ralph Garraway",
        loves: 1234,
    },
    {
        id: 4,
        thumbs: [
            { id: 1, source: postImage03 },
            { id: 2, source: postImage05 },
            { id: 3, source: postImage02 },
            { id: 4, source: postImage04 },
            { id: 5, source: postImage06 },
            { id: 6, source: postImage06 },
        ],
        profilePhoto: creativeCollProfile,
        profileName: "Creative Art Collection",
        isVerified: true,
        owner: "Ralph Garraway",
        loves: 1234,
    },

]




export interface dicoverTopCollectionsType {
    id: number,
    name: string,
    logo: string,
    rankRate: number | null,
    floorPrice: number,
    floorPrice2: number,
}

export const dicoverTopCollections: dicoverTopCollectionsType[] = [
    {
        id: 1,
        name: 'Paul George',
        logo: lowKey,
        rankRate: -31.80,
        floorPrice: 0.98,
        floorPrice2: 7796.74,
    },
    {
        id: 2,
        name: 'Paul George',
        logo: lowKey,
        rankRate: null,
        floorPrice: 0.98,
        floorPrice2: 7796.74,
    },
    {
        id: 3,
        name: 'Paul George',
        logo: lowKey,
        rankRate: 31.80,
        floorPrice: 0.98,
        floorPrice2: 7796.74,
    },
    {
        id: 4,
        name: 'Paul George',
        logo: lowKey,
        rankRate: null,
        floorPrice: 0.98,
        floorPrice2: 7796.74,
    },
    {
        id: 5,
        name: 'Paul George',
        logo: lowKey,
        rankRate: -31.80,
        floorPrice: 0.98,
        floorPrice2: 7796.74,
    },
    {
        id: 6,
        name: 'Paul George',
        logo: lowKey,
        rankRate: null,
        floorPrice: 0.98,
        floorPrice2: 7796.74,
    },

]




export interface dicoverTopSallerInDayDataType {
    id: number,
    userName: string,
    logo: string,
    price: number,
}

export const dicoverTopSallerInDayData: dicoverTopSallerInDayDataType[] = [
    {
        id: 1,
        userName: 'RollUpDeployer',
        logo: lowKey,
        price: 1896,
    },
    {
        id: 2,
        userName: 'RollUpDeployer',
        logo: lowKey,
        price: 1896,
    },
    {
        id: 3,
        userName: 'RollUpDeployer',
        logo: lowKey,
        price: 1896,
    },
    {
        id: 4,
        userName: '0x5c294b3fbb3fbb3fb...55e0',
        logo: lowKey,
        price: 1896,
    },
    {
        id: 5,
        userName: '0x5c294b3fbb3fbb3fb...55e0',
        logo: lowKey,
        price: 1896,
    },
    {
        id: 6,
        userName: '0x5c294b3fbb3fbb3fb...55e0',
        logo: lowKey,
        price: 1896,
    },


]








// explore filter section

export interface filterCollectionsDataType {
    id: number,
    collectionName: string,
    isActive?: boolean,
    logo: string,
    resultsNum: number,
    aditionalFilterItems: {
        itemName: string,
        lastSearchValue?: string,
        isMinMax?: boolean,
        isFilterSupport?: boolean,
        itemOptions: {
            optionName: any,
            optionResultNum: number,
        }[],
    }[],
}


export const filterCollectionsData: filterCollectionsDataType[] = [

    {
        id: 1,
        collectionName: "Polychain Monsters",
        logo: "https://cdn.tofunft.com/nfts/polkamon.png/128.jpg",
        resultsNum: 25550,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 2,
        collectionName: "Galaxy OAT",
        logo: "https://cdn.tofunft.com/nfts/f8gr1ms68lds51w.jpg/128.jpg",
        resultsNum: 7441,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 3,
        collectionName: "Catgirl NFT",
        logo: "https://cdn.tofunft.com/nfts/q1satutu4vws3i7.png/128.jpg",
        resultsNum: 6208,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },


            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 4,
        collectionName: "Mafagafo-Avatar",
        logo: "https://cdn.tofunft.com/nfts/nzye985f8o5t1pc.jpg/128.jpg",
        resultsNum: 3375,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },


            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 5,
        collectionName: "CryptoMines Fleet",
        logo: "https://cdn.tofunft.com/nfts/7cnxckr9g2vjcs0.jpg/128.jpg",
        resultsNum: 2964,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 6,
        collectionName: "Tales of Ragnarok-Avatar",
        logo: "https://cdn.tofunft.com/nfts/a1a12u2kok52nww.jpg/128.jpg",
        resultsNum: 2372,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },


            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },

            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 7,
        collectionName: "Freeport Metaverse PFP NFT",
        logo: "https://cdn.tofunft.com/nfts/8m9irizmmuyjla3.jpg/128.jpg",
        resultsNum: 2171,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 8,
        collectionName: "CrazyMiner",
        logo: "https://cdn.tofunft.com/nfts/3ufb5aac2i4fl15.jpg/128.jpg",
        resultsNum: 2089,
        aditionalFilterItems: [
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 9,
        collectionName: "ArmzLegendsV2",
        logo: "https://cdn.tofunft.com/nfts/5hcb1bz6i8smxk1.jpg/128.jpg",
        resultsNum: 1902,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 10,
        collectionName: "CryptoGodz Sentz",
        logo: "https://cdn.tofunft.com/nfts/45clzn2t7ds5zgs.jpg/128.jpg",
        resultsNum: 1865,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 11,
        collectionName: "Monsters Clan",
        logo: "https://cdn.tofunft.com/nfts/8iquaae5r6q748b.jpg/128.jpg",
        resultsNum: 1668,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 12,
        collectionName: "RankerDAO-Basic Guild Membership",
        logo: "https://cdn.tofunft.com/nfts/0lipktb57nniuvv.png/128.jpg",
        resultsNum: 1657,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },

            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 13,
        collectionName: "Legendary Monsters",
        logo: "https://cdn.tofunft.com/nfts/apnd3nhn6xosu5w.jpg/128.jpg",
        resultsNum: 1634,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 14,
        collectionName: "Magic Beasties-Magic Talismans",
        logo: "https://cdn.tofunft.com/nfts/2blh8tq9ssgx6ei.jpg/128.jpg",
        resultsNum: 1276,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },

        ]
    },

    {
        id: 15,
        collectionName: "Zodium-12 KINDs V1",
        logo: "https://cdn.tofunft.com/nfts/2qvqju68y0u0ht9.jpg/128.jpg",
        resultsNum: 1230,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 16,
        collectionName: "ExtensionPunks",
        logo: "https://cdn.tofunft.com/nfts/fob2cawtv9bcm4o.jpg/128.jpg",
        resultsNum: 1208,
        aditionalFilterItems: [

            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 17,
        collectionName: "UnusDao-Spice Game Equipment",
        logo: "https://cdn.tofunft.com/nfts/2exkz9q6d3lkijj.png/128.jpg",
        resultsNum: 1200,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 18,
        collectionName: "Plato Farm",
        logo: "https://cdn.tofunft.com/nfts/96k3n5t22ndsy88.jpg/128.jpg",
        resultsNum: 1190,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },

            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 19,
        collectionName: "Sovi Universe Unit",
        logo: "https://cdn.tofunft.com/nfts/96k3n5t22ndsy88.jpg/128.jpg",
        resultsNum: 1189,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 20,
        collectionName: "OmniMoonbirds",
        logo: "https://cdn.tofunft.com/frontend/Xg/3L3OaIm-NhvQgo/128.jpg",
        resultsNum: 1123,
        aditionalFilterItems: [

            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 21,
        collectionName: "Crypto Dogs Club AirDrop NFTs",
        logo: "https://cdn.tofunft.com/nfts/ffm3in8543mvf55.jpg/128.jpg",
        resultsNum: 1081,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 22,
        collectionName: "Cryptoz Cards",
        logo: "https://cdn.tofunft.com/nfts/cryptoz.png/128.jpg",
        resultsNum: 1074,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },

            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 23,
        collectionName: "Cosmic Apes",
        logo: "https://cdn.tofunft.com/nfts/oi92b30joc02znc.png/128.jpg",
        resultsNum: 1036,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },

            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 24,
        collectionName: "Crackin Krakens",
        logo: "https://cdn.tofunft.com/nfts/flwn9vpp8wjlx11.png/128.jpg",
        resultsNum: 1030,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },

            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 25,
        collectionName: "LootPunks",
        logo: "https://cdn.tofunft.com/nfts/lootpunks.png/128.jpg",
        resultsNum: 1001,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },

            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 26,
        collectionName: "Monsta Party",
        logo: "https://cdn.tofunft.com/nfts/2wx6zipoem72go4.png/128.jpg",
        resultsNum: 995,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },

            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 27,
        collectionName: "Farm Planet-Land NFT Game Pass",
        logo: "https://cdn.tofunft.com/nfts/1xoicidj6i8brkx.jpg/128.jpg",
        resultsNum: 993,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'COLOR',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Ada Blue", optionResultNum: 35, },
                    { optionName: "Basil Green", optionResultNum: 5, },
                    { optionName: "Beasty Green", optionResultNum: 25, },
                    { optionName: "Binary Shadow", optionResultNum: 31, },
                    { optionName: "Black", optionResultNum: 290, },
                    { optionName: "Blue", optionResultNum: 5442, },
                    { optionName: "Buttery Yellow", optionResultNum: 12, },
                    { optionName: "Byzantium", optionResultNum: 1, },
                    { optionName: "Chocolate Brown", optionResultNum: 21, },
                    { optionName: "Cosmic Caramel", optionResultNum: 3, },
                    { optionName: "Darkest Blue", optionResultNum: 1, },
                    { optionName: "Galactic Violet", optionResultNum: 2, },
                    { optionName: "Gleaming Gold", optionResultNum: 100, },
                    { optionName: "Green", optionResultNum: 6512, },
                    { optionName: "Lightning Black", optionResultNum: 12, },
                    { optionName: "Luminous Carbon", optionResultNum: 2, },
                    { optionName: "Majestic Violet", optionResultNum: 6, },
                    { optionName: "Memeingful Black", optionResultNum: 16, },
                    { optionName: "N3 Green", optionResultNum: 13, },
                    { optionName: "Neon Green", optionResultNum: 11, },
                    { optionName: "Oceanic", optionResultNum: 7, },
                    { optionName: "P2E Orange", optionResultNum: 11, },
                    { optionName: "Pancake Yellow", optionResultNum: 4, },
                    { optionName: "Paper White", optionResultNum: 9, },
                    { optionName: "Purple", optionResultNum: 3262, },
                    { optionName: "Rainbow Prism", optionResultNum: 5, },
                    { optionName: "Red", optionResultNum: 5007, },
                    { optionName: "Secret Orange", optionResultNum: 36, },
                    { optionName: "Sharding Blue", optionResultNum: 35, },
                    { optionName: "Volcanic Grey", optionResultNum: 4, },
                ]
            },
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 28,
        collectionName: "UnusDao-Spice Game",
        logo: "https://cdn.tofunft.com/nfts/lh4wh0yp59ky3r7.jpg/128.jpg",
        resultsNum: 982,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 29,
        collectionName: "Dream Card",
        logo: "https://cdn.tofunft.com/nfts/dreamgame.jpg/128.jpg",
        resultsNum: 887,
        aditionalFilterItems: [
            {
                itemName: 'BACKGROUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "$FURY Arena", optionResultNum: 11, },
                    { optionName: "Another Realm", optionResultNum: 2, },
                    { optionName: "Chamber of Treasures", optionResultNum: 100, },
                    { optionName: "Codyfight Arena", optionResultNum: 11, },
                    { optionName: "Coral Reef", optionResultNum: 1, },
                    { optionName: "Dancefloor", optionResultNum: 21, },
                    { optionName: "DeFi Launch Pad", optionResultNum: 2, },
                    { optionName: "Decentralized Empire", optionResultNum: 6, },
                    { optionName: "Deep Sky Network", optionResultNum: 31, },
                    { optionName: "Doge Universe", optionResultNum: 3, },
                    { optionName: "Grassland", optionResultNum: 5, },
                    { optionName: "Grassland Archipel ago", optionResultNum: 9, },
                    { optionName: "Green Gardens", optionResultNum: 1560, },
                    { optionName: "Green Reef", optionResultNum: 5, },
                    { optionName: "Haunted Hills", optionResultNum: 1715, },
                    { optionName: "Hidden Lands", optionResultNum: 36, },
                    { optionName: "Hunting Grounds", optionResultNum: 23, },
                    { optionName: "Mainframe", optionResultNum: 35, },
                    { optionName: "Mountain Range", optionResultNum: 20616, },
                    { optionName: "Multichain Ocean", optionResultNum: 7, },
                    { optionName: "Neoverse", optionResultNum: 13, },
                    { optionName: "Old Master Meme Gal'lery", optionResultNum: 16, },
                    { optionName: "Ouroboros Network", optionResultNum: 35, },
                    { optionName: "Polkadex Parachain", optionResultNum: 12, },
                    { optionName: "Popcorn Network", optionResultNum: 12, },
                    { optionName: "SCV Finance City", optionResultNum: 25, },
                    { optionName: "Skill City", optionResultNum: 1, },
                    { optionName: "The Pancake Bakery", optionResultNum: 4, },
                    { optionName: "Twilight Mountain 'Range", optionResultNum: 4, },
                    { optionName: "Winter Wonderland", optionResultNum: 1181, },
                ]
            },
            {
                itemName: 'OPENING NETWORK',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Binance Smart Chain", optionResultNum: 25370, },
                ]
            },
            {
                itemName: 'GLITTER',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 21847, },
                    { optionName: "Yes", optionResultNum: 3620, },
                ]
            },
            {
                itemName: 'SPECIAL',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "No", optionResultNum: 25051, },
                    { optionName: "Yes", optionResultNum: 451, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },

    {
        id: 30,
        collectionName: "OmniKiwami",
        logo: "https://cdn.tofunft.com/nfts/v077ydp3t2ibg7w.jpg/128.jpg",
        resultsNum: 876,
        aditionalFilterItems: [
            {
                itemName: 'Type',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Baby Uniaqua", optionResultNum: 127, },
                    { optionName: "Baby Unibranch", optionResultNum: 238, },
                    { optionName: "Baby Unichick", optionResultNum: 460, },
                    { optionName: "Baby Unidragon", optionResultNum: 57, },
                    { optionName: "Baby Unifairy", optionResultNum: 433, },
                    { optionName: "Baby Unikles", optionResultNum: 245, },
                    { optionName: "Binance Smart Chain Unidragon", optionResultNum: 4, },
                    { optionName: "Brokoli Uniturtle", optionResultNum: 5, },
                    { optionName: "Cardano Unibranch", optionResultNum: 35, },
                    { optionName: "Christmas Unibranch", optionResultNum: 21, },
                    { optionName: "Codyfight Uniair", optionResultNum: 11, },
                    { optionName: "Colchian Unidragon", optionResultNum: 100, },
                    { optionName: "Dogecoin Unishiba", optionResultNum: 3, },
                    { optionName: "Engines of Fury Unitiger", optionResultNum: 11, },
                    { optionName: "Ethereum Unikles", optionResultNum: 6, },
                    { optionName: "Genesis Island Land Ticket", optionResultNum: 9, },
                    { optionName: "Glitched Unidonkey", optionResultNum: 31, },
                    { optionName: "Monero Unicursed", optionResultNum: 36, },
                    { optionName: "MultiVAC Unipanda", optionResultNum: 35, },
                    { optionName: "Neo Unigiraffe", optionResultNum: 13, },
                    { optionName: "Old Master Unicursed", optionResultNum: 16, },
                    { optionName: "PancakeSwap Uniair", optionResultNum: 4, },
                    { optionName: "Polite Raptors Unidonkey", optionResultNum: 23, },
                    { optionName: "Polkadex Unikles", optionResultNum: 12, },
                    { optionName: "Popcorn Uniair", optionResultNum: 12, },
                    { optionName: "Rainbow Portal", optionResultNum: 5, },
                    { optionName: "Realm Uniphoenix", optionResultNum: 2, },
                    { optionName: "Reef Uniaqua", optionResultNum: 1, },
                    { optionName: "Skill Guilds Unikles", optionResultNum: 1, },
                    { optionName: "The Dancefloor", optionResultNum: 21, },
                ]
            },
            {
                itemName: 'HORN',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Antlers", optionResultNum: 17, },
                    { optionName: "Baby Horn", optionResultNum: 1560, },
                    { optionName: "Candy Cane", optionResultNum: 3065, },
                    { optionName: "Diamond Antlers", optionResultNum: 4, },
                    { optionName: "Diamond Spear", optionResultNum: 1128, },
                    { optionName: "Dragon Claw", optionResultNum: 1967, },
                    { optionName: "Golden Horn", optionResultNum: 3610, },
                    { optionName: "Ivory Fang", optionResultNum: 1507, },
                    { optionName: "Shadow Branch", optionResultNum: 1943, },
                    { optionName: "Silver Claw", optionResultNum: 1959, },
                    { optionName: "Silver Edge", optionResultNum: 3631, },
                    { optionName: "Spiral Horn", optionResultNum: 3623, },
                    { optionName: "Wicked Spear", optionResultNum: 1453, },
                ]
            },
            {
                itemName: 'BIRTHDAY',
                lastSearchValue: '',
                isMinMax: false,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'BOOSTER',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
            {
                itemName: 'SOUND',
                lastSearchValue: '',
                isMinMax: false,
                itemOptions: [
                    { optionName: "Classic", optionResultNum: 2, },
                    { optionName: "Hip - Hop", optionResultNum: 9, },
                    { optionName: "Rock", optionResultNum: 5, },
                    { optionName: "Salsa", optionResultNum: 4, },
                    { optionName: "Techno", optionResultNum: 1, },
                ]
            },
            {
                itemName: 'STAKING SCORE',
                lastSearchValue: '',
                isMinMax: true,
                isFilterSupport: true,
                itemOptions: [],
            },
        ]
    },
]















